import qs from 'qs';
import axios from "axios";
import { CONTENT_TYPE } from '@/apis/constant';

const otpSendClient = axios.create();

export const getAccountInfo = () => {
    return axios.get("/opc/account/info");
}

let _getAccountInfoCachePromise = null;
let _getAccountInfoCacheResponse = null;

export const clearGetAccountInfoCache = () => {
  _getAccountInfoCachePromise = null;
  _getAccountInfoCacheResponse = null;
};

export const getAccountInfoCached = ({ force = false } = {}) => {
  if (!force) {
    if (_getAccountInfoCacheResponse) {
      return Promise.resolve(_getAccountInfoCacheResponse);
    }
    if (_getAccountInfoCachePromise) {
      return _getAccountInfoCachePromise;
    }
  }

  _getAccountInfoCachePromise = getAccountInfo()
    .then((resp) => {
      _getAccountInfoCacheResponse = resp;
      return resp;
    })
    .finally(() => {
      _getAccountInfoCachePromise = null;
    });

  return _getAccountInfoCachePromise;
};

// check email/check pass/create temp user
export const signUp = (params = {}) => axios.post("/opc/buy/signup", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

// todo: auto show captcha dialog when errorCode is 10006
// errorCode: 10006
// errorMessage: "CAPTCHA_REQUIRED"
// test account: lyon.li+260310001@zoom.us
export const sendEmailVerificationCode = (params = {}) => otpSendClient.post(
  "/buy/otp/sendcode",
  params,
  {
    headers: {
      'Content-Type': CONTENT_TYPE.JSON,
    },
  }
);

// gdpr countries users update agreements info
export const gdprCall = (params = {}) => axios.post("/opt_gdprcall", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const logout = () => axios.get('/logout');

export const checkCorporateDomain = (email) => {
  return axios.get(`/billing/personal_domain/block?emailAddress=${email}`);
};
